export const usersEnum = {
    allUsers: 'All GlassHive users',
    masterAgency: 'Master Agency users',
    vendor: 'Vendor users',
    partner: 'Partner users',
}